<div *ngIf="navaids.length > 0; else placeholder" class="navaid-listing">
  <app-navaid *ngFor="let navaid of sortedNavaids" [navaid]="navaid"
              (navaidDeleted)="onNavaidDeleted($event)" class="navaid-listing__navaid"></app-navaid>
</div>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no navaids near {{identifier.toUpperCase().startsWith('ZZ') ? 'this airport' : identifier}}.</div>
  </div>
</ng-template>
